// Point to the local Netlify function
export const AFFILIATE_ENDPOINT = '/.netlify/functions/generate-link';
export const INTEGRATION_ENDPOINT = '/.netlify/functions/check-integrations';

// Env
export function getAppEnv() {
  return (
    (typeof import.meta !== "undefined" && (import.meta as any).env?.VITE_APP_ENV) ||
    (typeof process !== "undefined" && (process as any).env?.APP_ENV) ||
    "local"
  );
}
